/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ retryAfterSeconds: NonNullable<unknown> }} Otp_Too_Many_AttemptsInputs */

const en_us2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Too many attempts. Try again in 1 second.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Too many attempts. Try again in 1 second.`);
	return /** @type {LocalizedString} */ (`Too many attempts. Try again in ${i?.retryAfterSeconds} seconds.`)
	
};

const pt_br2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Muitas tentativas. Tente de novo em 1 segundo.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Muitas tentativas. Tente de novo em 1 segundo.`);
	return /** @type {LocalizedString} */ (`Muitas tentativas. Tente de novo em ${i?.retryAfterSeconds} segundos.`)
	
};

const es_419_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Demasiados intentos. Intenta de nuevo en 1 segundo.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Demasiados intentos. Intenta de nuevo en 1 segundo.`);
	return /** @type {LocalizedString} */ (`Demasiados intentos. Intenta de nuevo en ${i?.retryAfterSeconds} segundos.`)
	
};

const pt_pt2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Demasiadas tentativas. Tenta outra vez dentro de 1 segundo.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Demasiadas tentativas. Tenta outra vez dentro de 1 segundo.`);
	return /** @type {LocalizedString} */ (`Demasiadas tentativas. Tenta outra vez dentro de ${i?.retryAfterSeconds} segundos.`)
	
};

const fr_fr2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Trop de tentatives. Réessaie dans 1 seconde.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Trop de tentatives. Réessaie dans 1 seconde.`);
	return /** @type {LocalizedString} */ (`Trop de tentatives. Réessaie dans ${i?.retryAfterSeconds} secondes.`)
	
};

const de_de2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Zu viele Versuche. Versuch es in 1 Sekunde noch mal.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Zu viele Versuche. Versuch es in 1 Sekunde noch mal.`);
	return /** @type {LocalizedString} */ (`Zu viele Versuche. Versuch es in ${i?.retryAfterSeconds} Sekunden noch mal.`)
	
};

const it_it2_otp_too_many_attempts = /** @type {(inputs: Otp_Too_Many_AttemptsInputs) => LocalizedString} */ (i) => {
	if ((i?.retryAfterSeconds === 1 || i?.retryAfterSeconds === "1")) return /** @type {LocalizedString} */ (`Troppi tentativi. Riprova tra 1 secondo.`);
	if ((i?.retryAfterSeconds === -1 || i?.retryAfterSeconds === "-1")) return /** @type {LocalizedString} */ (`Troppi tentativi. Riprova tra 1 secondo.`);
	return /** @type {LocalizedString} */ (`Troppi tentativi. Riprova tra ${i?.retryAfterSeconds} secondi.`)
	
};

/**
* | retryAfterSeconds | output |
* | --- | --- |
* | "1" | "Too many attempts. Try again in 1 second." |
* | "-1" | "Too many attempts. Try again in 1 second." |
* | * | "Too many attempts. Try again in {retryAfterSeconds} seconds." |
*
* @param {Otp_Too_Many_AttemptsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const otp_too_many_attempts = /** @type {((inputs: Otp_Too_Many_AttemptsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otp_Too_Many_AttemptsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_otp_too_many_attempts(inputs)
	if (locale === "es-419") return es_419_otp_too_many_attempts(inputs)
	if (locale === "pt-PT") return pt_pt2_otp_too_many_attempts(inputs)
	if (locale === "fr-FR") return fr_fr2_otp_too_many_attempts(inputs)
	if (locale === "de-DE") return de_de2_otp_too_many_attempts(inputs)
	if (locale === "it-IT") return it_it2_otp_too_many_attempts(inputs)
	return en_us2_otp_too_many_attempts(inputs)
});
export { otp_too_many_attempts as "otp.too_many_attempts" }